App.TimetableTransform = DS.Transform.extend
  normalizeTime: (time) ->
    t = moment.parseZone(time)
    moment(
      y: 2000
      M: 0
      d: 1
      h: t.hour()
      m: t.minute()
      s: t.second()
      ms: 0
    ).toDate()

  deserialize: (serialized) ->
    serialized?.map (timetable) =>
      Em.Object.create
        id:         timetable.id
        date:       timetable.date
        day:        timetable.day
        is_working: timetable.is_working
        open_at:    @normalizeTime(timetable.open_at)
        close_at:   @normalizeTime(timetable.close_at)

  serialize: (deserialized) ->
    deserialized?.map (t) =>
      id:         t.get('id')
      day:        t.get('day')
      date:       t.get('date')
      is_working: t.get('is_working')
      open_at:    t.get('open_at').toString()
      close_at:   t.get('close_at').toString()
